import config from '../config.json';
import axios from '../utils/axiosInstance';
import React, { useState, useEffect } from 'react';
import IndexPage_Navbar from '../components/IndexPage_Navbar';
import {
  Grid,
  Select,
  InputLabel,
  MenuItem,
  FormControl,
  Box,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import io from 'socket.io-client';
import ActivityCard from '../components/ActivityCard';
import url from '../url.json';



export default function Index() {
  const [all, setAll] = useState('');
  const [activities, setActivities] = useState([]);
  const [ws, setWs] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [sortOrder, setSortOrder] = useState('new_to_old'); // 加入排序選擇
  const handleChange = (event) => {
    setSortOrder(event.target.value);  };

  const connectWebSocket = () => {
    setWs(io(url.backendHost));
  };

  useEffect(() => {
    const getActivities = async () => {
      try {
        const fetchData = await axios.get(`${url.backendHost + config.myJoinedActivityList}/${localStorage.getItem('userId')}`);
        setActivities(fetchData.data);
        console.log("fetchData: ", fetchData.data)
      } catch (err) {
        // console.log(err);
      }
    };
    getActivities();

    if (ws) {
      initWebSocket();
    }
  }, [ws]);

  const initWebSocket = () => {
    ws.on('connect', () => {
      // console.log(ws.id);
    });

    ws.on('event02', (arg, callback) => {
      // console.log(arg);
      callback({
        status: 'event02 ok',
      });
    });
  };
  const sortedActivities = [...activities].sort((a, b) => {
    const dateA = new Date(a.createdAt);
    const dateB = new Date(b.createdAt);
    return sortOrder === 'new_to_old' ? dateB - dateA : dateA - dateB;

  });
  return (
    <div className="home-container">
      <IndexPage_Navbar callback_setActivities={setActivities}/>
      <h2>我們的探究活動</h2>
      <Box sx={{ maxWidth: 120 }} className="activity-status">
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">排序</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={sortOrder}
            label="排序"
            onChange={handleChange}
          >
            <MenuItem value="new_to_old">新到舊</MenuItem>
            <MenuItem value="old_to_new">舊到新</MenuItem>
          </Select>
        </FormControl>
      </Box>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="stretch"
        spacing={3}
        style={{ paddingRight: '120px', paddingLeft: '120px' }}
      >
        {sortedActivities.map((activity) => (
        <Grid item xs={8} sm={isMobile ? 8 : 4} key={activity.id}>
          <ActivityCard activity={activity} />
        </Grid>
      ))}
      </Grid>
    </div>
  );
}